// Main Custom Scripts File
(function($) {
	
	var globalEase        = Power2.easeInOut,
		backgroundClasses = [];
	
	if( typeof ScrollMagic !== 'undefined' ) {
		
		// Bugfix for setClassToggle issue
		// See: https://github.com/janpaepke/ScrollMagic/issues/313
		
		
		ScrollMagic._util.addClass = function _patchedAddClass(elem, classname) {
			if (classname) {
				if (elem.classList) {
					classname.split(' ').forEach(function _addCls(c) {
						elem.classList.add(c);
					});
				} 
				else {
					elem.className += ' ' + classname;
				}
			}
		};
		ScrollMagic._util.removeClass = function _patchedRemoveClass(elem, classname) {
			if (classname) {
				if (elem.classList) {
					classname.split(' ').forEach(function _removeCls(c) {
						elem.classList.remove(c);
					});
				} 
				else  {
					elem.className = elem.className.replace(new RegExp('(^|\b)' + classname.split(' ').join('|') + '(\b|$)', 'gi'), ' ');
				}
			}
		};		
	}
	
	$(document).ready(function() {
		wpFoundation();
		$(document).foundation();
		offCanvasEvents();
		contentSliderInit();
		infiniteScrollInit();
		stickyHeaderMobile();
	});
	
	$(window).load(function() {
		animationInit();
		footerParallax();
		instagramSliderInit();
		lazyLoading();
		imageSliderInit();
		footerRevealListener();
	});
	
	window.addEventListener('resize', function() {
		footerParallax();
	});
	
	window.addEventListener('scroll', function() {
		footerRevealListener();
	});

	// Foundation helper function
	function wpFoundation()
	{
		// Remove empty P tags created by WP inside of Accordion and Orbit
		$('.accordion p:empty, .orbit p:empty').remove();

		// Makes sure last grid item floats left
		$('.archive-grid .columns').last().addClass( 'end' );

		// Adds Flex Video to YouTube and Vimeo Embeds
		$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
			if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) 
			{
				$(this).wrap('<div class="widescreen responsive-embed"/>');
			} 
			else 
			{
				$(this).wrap('<div class="responsive-embed"/>');
			}
		});		
	}
	
	function lazyLoading() {
		var $pageContent = document.getElementById('offCanvasContent');
		
		TweenMax.to($pageContent, .3, { autoAlpha: 1, ease: Power2.easeIn} );
	}
	
	function isSlickLoaded() {
		return typeof $().slick === 'function';
	}
	
	function animationInit() {
		var $background = document.getElementById('main');
			
		animateSectionBackgrounds($background);
		animateIntro($background);
		animateFeaturedComponents('.c-featured-project', '.c-featured-project_details'); 
		animateFeaturedComponents('.c-featured-image', '.c-featured-image_details');
		animateHexGridCardFlip();
		animateProjectHero();
	}
	
	function animateIntro($background) {
	
		var $container = document.getElementById('js-scrollContainer'),
			$wrapper   = document.getElementById('js-introWrapper'),
			$intro     = document.getElementById('js-intro'),
			$trigger   = document.getElementById('js-introAnimationTrigger');
		
		
		if( $container !== null && $wrapper !== null && typeof ScrollMagic !== 'undefined' ) {
			
			var $nextSection = $wrapper.nextSibling;
			
			// Add state class to body to indicate the header images should fade in
			document.body.classList.add('js-animated-sections');
			
			// Only animate if there is another sibling after the intro
			if( $nextSection !== null ) {
					
				var controller           = new ScrollMagic.Controller({
						globalSceneOptions: {
// 							addIndicators: true
						}
					}),
					triggerHookLandscape = .6666,
					triggerHookPortrait  = .3333;
				
				// Fade intro out on scroll
				var scene = new ScrollMagic.Scene({
					triggerElement: $trigger
				});
				
				if( matchMedia('(orientation: portrait)').matches ) {
					scene.triggerHook(triggerHookPortrait);
				}
				else {
					scene.triggerHook(triggerHookLandscape);
				}
				
				scene.setTween( $intro, .4, {autoAlpha: 0, ease: globalEase} )
					 .setClassToggle('body', 'js-header-images-visible')
					 .addTo(controller);
				
				// As scene fades out...
				scene.on('enter', function() {
					// Toggle Class after animation completes
					setTimeout(function() {					
						$intro.classList.remove('c-intro--visible');
					}, 1000);
				})
				
				// As scene fades in...
				scene.on('leave', function() {
					$intro.classList.add('c-intro--visible');
					
					// Remove all background classes from background element
					$background.classList.remove(...backgroundClasses);
				});
				
				window.addEventListener('resize', function() {						
					if( matchMedia('(orientation: portrait)').matches ) {
						scene.triggerHook(triggerHookPortrait);
					}
					else {
						scene.triggerHook(triggerHookLandscape);
					}
					
				});
			}
			
			setTimeout(function() {
					
				// If we aren't scrolled below the intro, make it visible		
				if( window.pageYOffset <= $wrapper.offsetHeight ) {
					$intro.classList.add('js-loaded');
					$intro.classList.add('c-intro--visible');
				}
				else {
					setTimeout(function() {
						$intro.classList.add('js-loaded');
						$intro.classList.remove('c-intro--visible');
					}, 2000);
				}
				
			}, 1000);
		
		}
		else {
			document.body.classList.add('js-header-images-visible');
			
			if( $wrapper ) {				
				window.addEventListener('scroll', function() {
					var scrollPos = window.pageYOffset,
						trigger   = $wrapper.offsetHeight * .5;
					
					if( scrollPos <= trigger ) {
						// Remove all background classes from background element
						$background.classList.remove(...backgroundClasses);					
					}
				});
			}
		}
	}
	
	function animateFeaturedComponents(sectionSelector, detailsSelector) {
		
		var $sections = document.querySelectorAll(sectionSelector);
		
		
		if( $sections.length && typeof ScrollMagic !== 'undefined' ) {
			
			var controller = new ScrollMagic.Controller({
				globalSceneOptions: {
// 					addIndicators: true
				}
			});
			
			for( var i = 0; i < $sections.length; i++ ) {
				
				var $section = $sections[i],
					$details = $section.querySelector(detailsSelector), 
					scene    = new ScrollMagic.Scene({
						offset: 0,
						triggerElement: $section,
						triggerHook: .3333
					});
			
				// Setup initial state for this element
				TweenMax.set($details, {autoAlpha: 0});
				
				scene.setTween($details, 1, {y: '-50%', autoAlpha: 1, ease: globalEase}, 1)
					  .addTo(controller);
			}
			
			animationBreakpointCheck();
		
			
			// Check breakpoint to see if animation should run
			window.addEventListener('resize', animationBreakpointCheck); 
			 
		}
		
		function animationBreakpointCheck() {
			var controllerEnabled = controller.enabled();
			
			if( !Foundation.MediaQuery.atLeast('tablet') && controllerEnabled ) {
				
				// Disable Controller
				controller.enabled(false);
				controller.update(true);
				
				// Clear all animated styles from the element
				TweenMax.set(detailsSelector, {clearProps: 'all'});
				
			}
			else if( Foundation.MediaQuery.atLeast('tablet') && !controllerEnabled ) {				
				controller.enabled(true);
				controller.update(true);	
			}			
		}	
	}
	
	function animateSectionBackgrounds($background) {
		var $sections = Array.from(document.querySelectorAll('.js-animate-background'));
		
		if( $sections.length && typeof ScrollMagic !== 'undefined' ) {
			
			var controller = new ScrollMagic.Controller({
				globalSceneOptions: {
// 					addIndicators: true
				}
			});
				
			// Get all background classes
			$sections.forEach(function($section) {
				var backgroundClass = $section.getAttribute('data-background-class');
				
				if( backgroundClass && backgroundClasses.indexOf(backgroundClass) === -1 ) {
					backgroundClasses.push(backgroundClass);
				}
			});
			
			$sections.forEach(function($section) {
				
				
				var $firstChild     = $section.firstElementChild,
					backgroundClass = $section.getAttribute('data-background-class'),
					scene           = new ScrollMagic.Scene({
						triggerElement: $firstChild,
						triggerHook: .5	
					});

					scene.on('start', function() {
						
						if( backgroundClasses.length ) {		
							// Remove all backround classes prior to adding any
							$background.classList.remove( ...backgroundClasses );
						}
						
						// If section has its own background class, add it					
						if( backgroundClass ) {	
							$background.classList.add(backgroundClass);
						}
					
					});
					
					scene.addTo(controller);
					
					var position = window.scrollY;
					
					window.addEventListener('scroll', function() {
						var scrollPos = window.scrollY;
						
						if( scrollPos > position ){
							
							if( scene.offset() !== 0 ) {
								scene.offset(0)
									 .update(true);
							}
						}
						else if( scrollPos < position ) {
							
							if( scene.offset() === 0 ) {
								scene.offset( $section.offsetHeight)
									 .update(true);
							}
						}
						
						position = scrollPos;
					});
					
			});
		}
	}
	
	function footerParallax() {
		var $footer          = document.getElementById('footer'),
			$footerSubscribe = document.getElementById('footerSubscribe');
		
		if( $footerSubscribe ) {			
			var footerSubscribeMargin = $footerSubscribe.style.marginBottom,
				footerHeight          = $footer.offsetHeight;
				
			if( footerSubscribeMargin !== footerHeight ) {
				$footerSubscribe.style.marginBottom = footerHeight + 'px';
			}
		}
	}
	
	function footerRevealListener() {
		var $footer = document.getElementById('footer'),
			atTop   = window.pageYOffset <= 0;
		
		// If not on the 404 page, toggle visibility class
		if( !document.body.classList.contains('error404') ) {
			$footer.classList.toggle('invisible', atTop);
		}
	}
	
	function offCanvasEvents() {
		var $offCanvasPrimary       = document.getElementById('offCanvas'),
			$offCanvasNested        = document.getElementById('nestedOffCanvas'),
			$offCanvasNestedContent = $offCanvasNested.querySelector('.off-canvas-nested_content'),
			toggleLinksSelector     = '.off-canvas-nested_toggle > a',
			offCanvasTouch          = new Hammer.Manager($offCanvasPrimary),
			swipe                   = new Hammer.Swipe();
			
		document.addEventListener('click', function(e) {
			
			var nestedOffCanvasActive = $offCanvasPrimary.classList.contains('off-canvas-nested--active'),
				$parent               = e.target.parentNode, // Get the parent of the click target
				viewingProjects       = $offCanvasNested.classList.contains('off-canvas-nested--projects'),
				viewingPosts          = $offCanvasNested.classList.contains('off-canvas-nested--posts');
			
			// If clicking a menu item that triggers the off-canvas nav...
			if( e.target.closest(toggleLinksSelector) ) {				
				e.preventDefault();
				
				// If the trigger is for projects...
				if( $parent.classList.contains('off-canvas-nested_toggle--projects') ) {
					
					// Remove posts state class
					$offCanvasNested.classList.remove('off-canvas-nested--posts');
					
					// If nested off-canvas is open and we're already viewing projects, close the 
					// nested off-canvas
					if( nestedOffCanvasActive && viewingProjects ) {
						$offCanvasNested.classList.remove('off-canvas-nested--projects');
						$offCanvasPrimary.classList.remove('off-canvas-nested--active');						
					}
					// Otherwise, open the nested off-canvas and apply the projects state class
					else {
						$offCanvasNested.scrollTop = 0;
						$offCanvasNested.classList.add('off-canvas-nested--projects');
						$offCanvasPrimary.classList.add('off-canvas-nested--active');						
					}
					
				}
				// If the trigger is for posts...
				else if( $parent.classList.contains('off-canvas-nested_toggle--posts') ) {
					// Remove projects state class
					$offCanvasNested.classList.remove('off-canvas-nested--projects');
					
					// If nested off-canvas is open and we're already viewing posts, close the 
					// nested off-canvas
					if( nestedOffCanvasActive && viewingPosts ) {
						$offCanvasNested.classList.remove('off-canvas-nested--posts');
						$offCanvasPrimary.classList.remove('off-canvas-nested--active');						
					}
					// Otherwise, open the nested off-canvas and apply the posts state class
					else {
						$offCanvasNested.scrollTop = 0;
						$offCanvasNested.classList.add('off-canvas-nested--posts');
						$offCanvasPrimary.classList.add('off-canvas-nested--active');						
					}			
				}
			}
			else if( e.target.closest('.off-canvas_close') || e.target.closest('.js-off-canvas-overlay') ) {
				
				// Close nested off canvas if active
				if( nestedOffCanvasActive ) {
					$offCanvasPrimary.classList.remove('off-canvas-nested--active');
					$offCanvasNested.classList.remove('off-canvas-nested--projects', 'off-canvas-nested--posts');					

					// On tablet and larger, arrow closes both off-canvas areas
					if( Foundation.MediaQuery.atLeast('tablet') ) {
						setTimeout(function() {
							$($offCanvasPrimary).foundation('close');
						}, 600);
					}
				}
				
				else if( !nestedOffCanvasActive) {
					// If less than tablet breakpoint and nested offcanvas
					// is not active, close the primary offcanvas
					$($offCanvasPrimary).foundation('close');					
				}
			}
			else if( e.target.closest('.off-canvas-nested_close') ) {
				$offCanvasPrimary.classList.remove('off-canvas-nested--active');
				$offCanvasNested.classList.remove('off-canvas-nested--projects', 'off-canvas-nested--posts');
			}
		});
		
		$($offCanvasPrimary).on('opened.zf.offcanvas', function() {
			document.body.classList.add('off-canvas-active');
		});
		
		$($offCanvasPrimary).on('closed.zf.offcanvas', function() {
			document.body.classList.remove('off-canvas-active');
		});		
		
		// Add swipe to the Hammer Manager instance
		offCanvasTouch.add(swipe);
		
		// Handle swipe events
		offCanvasTouch.on('swipe', function (e) {			
			var nestedOffCanvasActive = $offCanvasPrimary.classList.contains('off-canvas-nested--active');
			
			// Check for right swipe
			if( e.offsetDirection === 4 && nestedOffCanvasActive ) {
				$offCanvasPrimary.classList.remove('off-canvas-nested--active');
			}
		});

		$offCanvasPrimary.addEventListener('touchstart', e => e.stopPropagation() );
		$offCanvasPrimary.addEventListener('touchmove', e => e.stopPropagation());
		$offCanvasPrimary.addEventListener('touchend', e => e.stopPropagation());
				
		$offCanvasNestedContent.addEventListener('touchstart', e => e.stopPropagation() );
		$offCanvasNestedContent.addEventListener('touchmove', e => e.stopPropagation());
		$offCanvasNestedContent.addEventListener('touchend', e => e.stopPropagation());		
		
	}
	
	function contentSliderInit() {
		var $sliderContainers = $('.c-content-slider');
		
		if( $sliderContainers.length && isSlickLoaded() ) {
			
			$sliderContainers.each(function() {
				var $slider = $(this).find('.c-content-slider_slides');
				$slider.slick({
					adaptiveHeight: false,
					arrows: true,
					dots: true,
					responsive: [{
						breakpoint: 768,
						settings: {
							arrows: false
						}
					}]
				});
			});
		}
	}
	
	function instagramSliderInit() {
		var $slider = $('#instagramSlider #sbi_images');
		
		if( $slider && isSlickLoaded() ) {
			
			setTimeout(function() {				
				$slider.slick({
					arrows: true,
					dots: false,
					infinite: false,
					slidesToScroll: 1,
					slidesToShow: 4,
					responsive: [
						{
							breakpoint: 1330,
							settings: {
								arrows: false,
								dots: true
							}
						},
						{
							breakpoint: 768,
							settings: {
								arrows: false,
								slidesToShow: 2,
								dots: true
							}
						},
						{
							breakpoint: 480,
							settings: {
								arrows: false,
								dots: true,
								slidesToShow: 1
							}
						}
					]
				});
			}, 2000);
			
		}
	}
	
	function infiniteScrollInit() {
		projectsInfiniteScroll();
		storiesInfiniteScroll();
	}
	
	function storiesInfiniteScroll() {
		var $allStories = $('.c-all-stories_grid');
		
		if( $allStories.length ) {			
			$allStories.jscroll({
				debug: true,
				loadingHtml: '<small>Loading...</small>',
			    nextSelector: '.next',
			    contentSelector: '.c-all-stories_grid'
			});
			
			$allStories.addClass('jscroll-loaded');	
		}
	}
	
	function projectsInfiniteScroll() {
		var $grid = $('.c-latest-projects--lazy-load .c-latest-projects_grid');
		
		if( $grid.length ) {		
			$grid.jscroll({
				loadingHtml: '<small>Loading...</small>',
			    nextSelector: '.next',
			    contentSelector: '.c-latest-projects--lazy-load .c-latest-projects_grid'
			});
			
			$grid.addClass('jscroll-loaded');			
		}
	}	
	
	function animateProjectHero() {
		var $hero = document.getElementById('projectHero');
		
		if( $hero ) {
			var $details      = document.getElementById('projectHeroDetails'),
				$info         = document.getElementById('projectHeroInfo'),
				$toggle       = document.getElementById('projectHeroToggle');
			
			// Calculate heights for animation
			calcProjectHeroDimensions($hero, $details, $info);
			
			// Set the details absolute height on initial load
			$details.style.height = $details.getAttribute('data-collapse-height');
			
			// Update heights for animation on resize
			window.addEventListener('resize', function() {
				var isExpanded = $details.classList.contains('c-project-hero_details--expanded');
				
				calcProjectHeroDimensions($hero, $details, $info);				
				
				if( isExpanded ) {
					var	collapseWidth   = $details.getAttribute('data-collapse-width'),
						collapseHeight  = $details.getAttribute('data-collapse-height');
						
/*
					if( Foundation.MediaQuery.atLeast('large') ) {
						collapseWidth = 'calc(41.6666666667% - 3.5rem)'; 
					}						
					else if( Foundation.MediaQuery.atLeast('tablet') ) {
						collapseWidth = 'calc(50% - 3.5rem)'; 			
					}
*/			
					
					setTimeout(function() {
						collapseDetails(collapseHeight, collapseWidth);
					}, 300);
				}
			});
			
			// Expanded/collapse button behavior
			$toggle.addEventListener('click', function() {
				var isExpanded      = $details.classList.contains('c-project-hero_details--expanded'),
					expandWidth     = $details.getAttribute('data-expand-width'),
					collapseWidth   = $details.getAttribute('data-collapse-width'),
					expandHeight    = $details.getAttribute('data-expand-height'),
					collapseHeight  = $details.getAttribute('data-collapse-height');
				
/*
				if( Foundation.MediaQuery.atLeast('large') ) {
					expandWidth   = 'calc(66.6666666667% - 3.5rem)';
					collapseWidth = 'calc(41.6666666667% - 3.5rem)'; 
				}
				else if( Foundation.MediaQuery.atLeast('tablet') ) {
					expandWidth   = 'calc(75% - 3.5rem)';
					collapseWidth = 'calc(50% - 3.5rem)'; 			
				}
*/
				
				if( isExpanded ) {
					// Animate elements
					collapseDetails(collapseHeight, collapseWidth);
				}
				else {					
					// Animate elements
					expandDetails(expandHeight, expandWidth);
				}
			});
			
		}

		function expandDetails(height, width) {
			$details.classList.add('c-project-hero_details--expanded');		
			TweenMax.to($details, .3, {height: height, width: width, ease: globalEase});
			TweenMax.to($info, .6, {autoAlpha: 1, ease: globalEase, delay: .3});			
		}
		
		function collapseDetails(height, width) {
			$details.classList.remove('c-project-hero_details--expanded');		
			TweenMax.to($details, .3, {height: height, width: width, ease: globalEase});
			TweenMax.to($info, .6, {autoAlpha: 0, ease: globalEase});				
		}
	}

	function calcProjectHeroDimensions($hero, $details, $info) {
		var isExpanded    = $details.classList.contains('c-project-hero_details--expanded'),
			expandWidth   = '100%',
			collapseWidth = '75%',		
			infoHeight,
			detailsExpandHeight,
			detailsCollapseHeight,
			finalHeight;
		
		// Breakpoint check for width values
		if( Foundation.MediaQuery.atLeast('large') ) {
			expandWidth   = 'calc(66.6666666667% - 1.75rem)';
			collapseWidth = 'calc(41.6666666667% - 1.75rem)'; 
		}
		else if( Foundation.MediaQuery.atLeast('tablet') ) {
			expandWidth   = 'calc(75% - 1.75rem)';
			collapseWidth = 'calc(50% - 1.75rem)'; 			
		}
		
		// Add modifier class to prevent transition
		$details.classList.add('no-transition');
		
		// Store initial height at the time of check
		detailsCollapseHeight = $details.offsetHeight;
		
		// Set height to auto
		$details.style.height = 'auto';
		
		// Expand Details 
		$details.style.width = expandWidth;
		
		// Get current details height
		detailsExpandHeight = $details.offsetHeight;
		
/*
		if( detailsExpandHeight !== detailsCollapseHeight) {
			$details.style.height = detailsExpandHeight + 'px';
		}
		else {
			$details.style.height = detailsCollapseHeight + 'px';
		}
*/		
		
		// Get info height
		infoHeight = $info ? $info.offsetHeight : 0;
		
		// Reset details width
		$details.style.width = '';
		
		// Remove modifier class
		setTimeout(function() {		
			$details.classList.remove('no-transition');	
		}, 100);
		
		finalHeight = detailsExpandHeight + infoHeight + 'px';
		
		$details.setAttribute('data-expand-height', finalHeight );
		$details.setAttribute('data-collapse-height', detailsCollapseHeight + 'px');
		$details.setAttribute('data-expand-width', expandWidth);
		$details.setAttribute('data-collapse-width', collapseWidth);		
		
		// Set widths to actual values
		if( isExpanded ) {
			$details.style.width = expandWidth;
		}
		else {
			$details.style.width = collapseWidth;
		}		
	}
	
	function imageSliderInit() {
		var $sliders = $('.c-image-slider--slider-active .c-image-slider_slides');
		
		if( $sliders.length && isSlickLoaded() ) {
			$sliders.slick({
				dots: true,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							arrows: false
						}
					}
				]
			});
		}
	}
	
	function animateHexGridCardFlip() {
		var $hexGrid = document.getElementById('teamHexGrid');
		
		if( $hexGrid ) {
			var $cards = Array.from($hexGrid.querySelectorAll('.c-team-hex-grid_card--visible'));
			
			$cards.forEach(function($card) {
				var tlm    = new TimelineMax({
						paused: true, 
						onComplete: function() {
							$card.classList.add('flipped');
						}, onReverseComplete: function() {
							$card.classList.remove('flipped');
						}
					}),
					$front = $card.querySelector('.c-team-hex-grid_card-front'),
					$back  = $card.querySelector('.c-team-hex-grid_card-back');
				
				$card.timeline = tlm;

				tlm
				   .set($card, {clearProps: 'all'})
				   .set($front, {clearProps: 'transform'})
				   .set($back, {clearProps: 'transform'})
				   .to($card, .6, {rotationY: 180, ease: Power2.easeInOut})
				   .to($front, .625, {rotationY: 180, zIndex: 2, ease: Power2.easeInOut}, 0)
				   .to($back, .625, {rotationY: -180, zIndex: 3, ease: Power2.easeInOut}, 0);
				   
				$card.addEventListener('mouseenter', function() {
					if( whatInput.ask() !== 'touch' ) {
						tlm.play(0);
					}
				});
				
				$card.addEventListener('mouseleave', function() {
					if( whatInput.ask() !== 'touch' ) {
						tlm.reverse()
					}					
				});
				
				$card.addEventListener('click', function() {
					
					if( whatInput.ask() === 'touch' ) {						
						if( $card.classList.contains('flipped') ) {
							tlm.reverse();
						}
						else {
							tlm.play(0);
						}
					}	
								
				});				
				
			});
			
			hexCardTweensMediaQueryHandler();
		}
	}
	
	function hexCardTweensMediaQueryHandler() {
		var $hexGrid = document.getElementById('teamHexGrid'),
			$cards   = Array.from($hexGrid.querySelectorAll('.c-team-hex-grid_card--visible')),
			mql      = window.matchMedia('(min-width: 768px)');
		
		mql.addListener(function() {
			$cards.forEach(function($card) {
				$card.timeline.invalidate();
			});		
		});	
	}
	
	function stickyHeaderMobile() {
		var $header    = document.getElementById('header'),
			$container = document.getElementById('headerContainer');
		
		var scrollPosition = window.pageYOffset;
		
		window.addEventListener('scroll', function() {
			var scrollPos       = window.pageYOffset,
				containerHeight = $container.offsetHeight,
				scrollDirection = 'down';
				
			if( scrollPos < scrollPosition ) {
				scrollDirection = 'up';
			}
			 
			if( !Foundation.MediaQuery.atLeast('xlarge') ) {
				var hiddenCondition = scrollPos > containerHeight && scrollDirection === 'down',
					atBottom        = (window.innerHeight + window.scrollY) >= document.body.offsetHeight;
				
				if( atBottom ) {
					$header.classList.remove('sticky-hidden');
				}
				else {
					$header.classList.toggle('sticky-hidden', hiddenCondition);
				}
			}
			else {
				$header.classList.remove('sticky-hidden');
			}
			
			scrollPosition = scrollPos;
		});
	}
	
})(jQuery);
